import * as React from 'react';
import './TypeTestProfile.css';
import { AppStore } from '../../stores';
import { inject, observer } from 'mobx-react';
import { IType } from '../../interfaces/IType';
import DateTimeService from '../../services/DateTimeService';
import * as ReactGA from 'react-ga';
import TypeTestResultBar from '../resultBar/EnneagrammyResultBar';
import TypeTestChangeName from '../changeName/EnneagrammyChangeName';

export interface IProps {
  appStore?: AppStore;
}

export interface IState {
  opacity: number;
}

@inject('appStore')
@observer
export default class TypeTestProfile extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    this.state = {
      opacity: 0
    }
  }

  public componentDidMount(): void {
    this.props.appStore!.selectedTypeTestTab = 2;
    this.setState({ opacity: 0 });
    setTimeout(() => {
      this.setState({ opacity: 1 });
    }, 0);
  }

  private getTypeName(type: number): string {
    switch (type) {
      case 1:
        return window.loc.strings.type1;
      case 2:
        return window.loc.strings.type2;
      case 3:
        return window.loc.strings.type3;
      case 4:
        return window.loc.strings.type4;
      case 5:
        return window.loc.strings.type5;
      case 6:
        return window.loc.strings.type6;
      case 7:
        return window.loc.strings.type7;
      case 8:
        return window.loc.strings.type8;
      case 9:
        return window.loc.strings.type9;
      default:
        break;
    }
  }

  render() {
    const resultBars = [];
    let resultDate;
    let resultToShow;
    if (this.props.appStore!.myResult) {
      resultToShow = this.props.appStore!.myResult.pointsForTypes.map((type: IType) => {
        return {
          id: type.id,
          points: this.props.appStore!.myResult.splitTestResult && type.id === this.props.appStore!.myResult.splitTestResult ? type.points + 1 : type.points
        }
      });
      resultToShow = this.props.appStore!.sortByKey(resultToShow, "points");
      resultToShow.forEach((type: IType, index) => {
        resultBars.push(
          <TypeTestResultBar
            key={`resultBar_${type.id}`}
            type={type.id}
            points={type.points}
            backgroundColor={"#ffffff"}
            barColor={"#ffffff"}
            textColor={"#064859"}
            iconBackgroundColor={this.props.appStore!.typeTestColorLighter}
            iconTextColor={"#ffffff"}
            maxPoints={this.props.appStore!.myResult.splitTestResult ? this.props.appStore!.myResult.maxPoints + 1 : this.props.appStore!.myResult.maxPoints}
            winner={index === 0}
            onClick={() => {
              ReactGA.event({
                category: 'Tests',
                action: `User read description of type: ${type.id}`
              });
              this.props.appStore!.selectedTestResult = this.props.appStore!.myResult;
              this.props.appStore!.selectedType = type.id;
              this.props.appStore!.selectedTypeInfoTab = "type";
            }}
          />
        );
      });
      resultDate = DateTimeService.ConvertToDDMMYYYYHHMM(this.props.appStore!.myResult.createdAt)
    }
    return (
      <div style={{
        position: this.props.appStore!.isMobile ? "fixed" : "relative",
        width: "100%",
        height: this.props.appStore!.isMobile ? "calc(100% - 80px)" : "100%",
        overflow: this.props.appStore!.isMobile ? "auto" : "unset"
      }}>
        {this.props.appStore!.myResult ?
          <div className="enneagrammyResult">
            {/* <svg
              style={{
                position: "absolute",
                right: 10,
                top: -10,
                cursor: "pointer"
              }}
              height={24}
              width={24}
              viewBox="0 0 48 48"
              onClick={() => {
                this.props.appStore!.selectedTestResult = this.props.appStore!.myResult;
                this.props.appStore!.typeTestChangeName = true;
              }}
            >
              <path
                d="M24 16.4999C19.8579 16.4999 16.5 19.8578 16.5 23.9999C16.5 28.1421 19.8579 31.4999 24 31.4999C28.1421 31.4999 31.5 28.1421 31.5 23.9999C31.5 19.8578 28.1421 16.4999 24 16.4999ZM19 23.9999C19 21.2385 21.2386 18.9999 24 18.9999C26.7614 18.9999 29 21.2385 29 23.9999C29 26.7614 26.7614 28.9999 24 28.9999C21.2386 28.9999 19 26.7614 19 23.9999ZM19.4943 43.468C20.9727 43.8208 22.4874 43.999 24.0073 43.999C25.524 43.9974 27.0353 43.8182 28.5103 43.465C28.898 43.3716 29.2476 43.161 29.5114 42.8618C29.7751 42.5626 29.9402 42.1894 29.9843 41.793L30.3223 38.722C30.3794 38.1728 30.6307 37.662 31.0309 37.2816C31.4311 36.9012 31.9539 36.6762 32.5053 36.647C32.8719 36.6311 33.2372 36.6995 33.5732 36.847L36.3803 38.078C36.6243 38.1877 36.8886 38.2452 37.1562 38.2469C37.4238 38.2487 37.6888 38.1945 37.9343 38.088C38.1807 37.9827 38.4022 37.8266 38.5843 37.63C40.6483 35.4053 42.1891 32.7475 43.0943 29.851C43.2128 29.4667 43.2091 29.0552 43.0837 28.6731C42.9583 28.291 42.7174 27.9573 42.3943 27.718L39.9003 25.878C39.6032 25.6622 39.3614 25.3793 39.1947 25.0522C39.028 24.7251 38.9411 24.3631 38.9411 23.996C38.9411 23.6289 39.028 23.2669 39.1947 22.9398C39.3614 22.6127 39.6032 22.3297 39.9003 22.114L42.3863 20.278C42.7104 20.0383 42.9519 19.7038 43.0774 19.3207C43.2028 18.9376 43.2059 18.5249 43.0863 18.14C42.1808 15.243 40.6381 12.5857 38.5713 10.363C38.2974 10.0703 37.9395 9.86982 37.5469 9.78922C37.1542 9.70861 36.7463 9.75187 36.3793 9.91299L33.5732 11.149C33.2821 11.2802 32.9666 11.3483 32.6473 11.349C32.0711 11.3481 31.5155 11.1345 31.0872 10.7491C30.6588 10.3638 30.3879 9.83385 30.3263 9.26099L29.9863 6.20099C29.9428 5.79937 29.7748 5.42138 29.5058 5.11996C29.2368 4.81855 28.8804 4.60878 28.4863 4.51999C27.019 4.19242 25.5216 4.01847 24.0183 4.00098C22.5043 4.01846 20.9963 4.19274 19.5183 4.521C19.1246 4.60928 18.7684 4.81836 18.4995 5.11905C18.2305 5.41974 18.0623 5.79699 18.0183 6.198L17.6773 9.25998C17.6134 9.83345 17.3403 10.3632 16.9103 10.748C16.471 11.1211 15.9174 11.3328 15.3413 11.348C15.0235 11.3478 14.7092 11.2817 14.4183 11.154L11.6183 9.918C11.25 9.75542 10.8403 9.71157 10.4461 9.79257C10.0518 9.87358 9.69255 10.0754 9.41827 10.37C7.35399 12.5931 5.81275 15.2495 4.90726 18.145C4.78769 18.5298 4.79083 18.9423 4.91627 19.3252C5.0417 19.7081 5.2832 20.0425 5.60726 20.282L8.09626 22.118C8.39089 22.3355 8.63046 22.6191 8.79578 22.9459C8.9611 23.2727 9.04758 23.6337 9.04827 24C9.0486 24.3669 8.9626 24.7286 8.79722 25.0561C8.63183 25.3836 8.3917 25.6675 8.09626 25.885L5.60627 27.724C5.2826 27.9633 5.04136 28.2974 4.91595 28.6799C4.79053 29.0624 4.78714 29.4745 4.90626 29.859C5.80978 32.7571 7.35083 35.4162 9.41627 37.641C9.59569 37.8352 9.81367 37.9898 10.0563 38.095C10.301 38.2026 10.5654 38.2581 10.8328 38.2581C11.1001 38.2581 11.3645 38.2026 11.6093 38.095L14.4283 36.858C14.7191 36.7298 15.0335 36.6637 15.3513 36.664H15.3593C15.9331 36.6647 16.4866 36.8765 16.9144 37.2589C17.3422 37.6414 17.6145 38.1678 17.6793 38.738L18.0173 41.795C18.0614 42.1919 18.227 42.5656 18.4913 42.865C18.7556 43.1644 19.1059 43.375 19.4943 43.468ZM27.5583 41.123C25.2181 41.6234 22.7985 41.6234 20.4583 41.123L20.1543 38.461C20.0221 37.2798 19.4597 36.1886 18.5744 35.3955C17.6891 34.6024 16.5429 34.1629 15.3543 34.161H15.3443C14.6814 34.1583 14.0253 34.2945 13.4183 34.561L10.9723 35.634C9.38518 33.8444 8.17417 31.754 7.41126 29.487L9.57726 27.887C10.1874 27.4371 10.6833 26.8502 11.025 26.1736C11.3668 25.497 11.5449 24.7495 11.5449 23.9915C11.5449 23.2334 11.3668 22.486 11.025 21.8094C10.6833 21.1328 10.1874 20.5459 9.57726 20.096L7.41326 18.496C8.17734 16.2316 9.38828 14.1437 10.9743 12.356L13.4063 13.428C14.0144 13.6972 14.6722 13.8358 15.3373 13.835H15.3473C16.5387 13.8327 17.6877 13.3919 18.5748 12.5966C19.462 11.8012 20.0253 10.7071 20.1573 9.52298L20.4573 6.86298C21.6304 6.6279 22.8229 6.50205 24.0193 6.487C25.2063 6.50208 26.3894 6.62762 27.5533 6.862L27.8533 9.521C27.9816 10.705 28.5424 11.8 29.4281 12.596C30.3139 13.3921 31.4623 13.8333 32.6533 13.835C33.3249 13.8509 33.9911 13.7105 34.5993 13.425L37.0293 12.354C38.6163 14.1415 39.8276 16.2299 40.5913 18.495L38.4343 20.088C37.8198 20.5358 37.3199 21.1226 36.9752 21.8003C36.6305 22.478 36.4508 23.2276 36.4508 23.988C36.4508 24.7483 36.6305 25.4979 36.9752 26.1757C37.3199 26.8534 37.8198 27.4401 38.4343 27.888L40.5993 29.488C39.8348 31.752 38.6243 33.8398 37.0393 35.628L34.5983 34.558C33.9037 34.2496 33.146 34.1098 32.3872 34.1501C31.6283 34.1905 30.8897 34.4098 30.2318 34.7901C29.5738 35.1704 29.0152 35.701 28.6014 36.3384C28.1877 36.9759 27.9307 37.7022 27.8513 38.458L27.5583 41.123Z"
                fill={"#ffffff"}
              />
            </svg> */}
            <div
              className="enneagrammyResultNumber"
              style={{
                backgroundColor: this.props.appStore!.typeTestColorLighter
              }}
              onClick={() => {
                this.props.appStore!.selectedTestResult = this.props.appStore!.myResult;
                this.props.appStore!.selectedType = resultToShow[0].id;
                this.props.appStore!.selectedTypeInfoTab = "type";
              }}
            >
              {resultToShow[0].id}
            </div>
            <div
              className="enneagrammyResultName"
              style={{
                color: this.props.appStore!.typeTestColorLighter
              }}
              onClick={() => {
                this.props.appStore!.selectedTestResult = this.props.appStore!.myResult;
                this.props.appStore!.selectedType = resultToShow[0].id;
                this.props.appStore!.selectedTypeInfoTab = "type";
              }}
            >
              {this.getTypeName(resultToShow[0].id)}
            </div>
            <div
              className="enneagrammyResultHeadline"
              onClick={() => {
                this.props.appStore!.selectedTestResult = this.props.appStore!.myResult;
                this.props.appStore!.typeTestChangeName = true;
              }}
            >
              {this.props.appStore!.myResult && this.props.appStore!.myResult.name ? this.props.appStore!.myResult.name : window.loc.strings.latestResult}
            </div>
            <div className="enneagrammyResultDate">{this.props.appStore!.myResult && this.props.appStore!.myResult.createdAt ? DateTimeService.ConvertToDDMMYYYYHHMM(this.props.appStore!.myResult.createdAt) : ""}</div>
            <div
              className="resultBars"
            >
              {resultBars}
            </div>
            {/* <div className="enneagrammyResultMoreInfo">{window.loc.strings.testResultInfo}</div> */}
            <div
              className={this.props.appStore!.isMobile ? "detailsBtnMobile" : "detailsBtn"}
              onClick={() => {
                this.props.appStore!.selectedTestResult = this.props.appStore!.myResult;
                this.props.appStore!.selectedType = resultToShow[0].id;
                this.props.appStore!.selectedTypeInfoTab = "type";
              }}
            >
              {window.loc.strings.details}
            </div>
          </div>
          :

          ((localStorage.getItem("typeTestAccess") || this.props.appStore!.user.userType === "admin") ?
            <div className="enneagrammyNoResults">
              Du har ingen testresultater at vise
              {localStorage.getItem("typeTestAccess") &&
                <div
                  className="startTheTest"
                  style={{
                    backgroundColor: this.props.appStore!.typeTestColor
                  }}
                  onClick={() => {
                    this.props.appStore!.startTest();
                  }}
                >
                  {window.loc.strings.takeATestNow}
                </div>
              }
            </div>
            :
            <div
              className="startBtn"
              style={{
                backgroundColor: "#064859"
              }}
              onClick={() => this.props.appStore!.isShowingSubscriptionPopup = true}
            >
              {window.loc.strings.openShop}
            </div>
          )
        }
        {this.props.appStore!.typeTestChangeName && this.props.appStore!.isMobile &&
          <div
            className="enneagrammyChangeNameBoxContainer"
          >
            <div className="enneagrammyChangeNameBox">
              <TypeTestChangeName />
            </div>
          </div>
        }
      </div >
    );
  }

}